import React, { useState } from 'react';

const Contact: React.FC = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setError('Please fill in all fields.');
      return;
    }
    setError('');

    try {
      // const response = await fetch('http://localhost:8080/support/contact_us_form_submit', {
      const response = await fetch('https://remindme-planet.appspot.com/support/contact_us_form_submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      });

      if (!response.ok) {
        throw new Error('Failed to submit the form. Please try again later.');
      }

      setSubmitted(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred.');
    }
  };

  return (
    <div className="max-w-xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold mb-8 text-center">Contact Us</h1>
      <div className="mb-8 bg-white rounded-xl shadow p-6">
        <h2 className="text-xl font-semibold mb-2">Support Channels</h2>
        <ul className="list-disc pl-6 text-gray-800">
          <li>
            Twitter: <a href="https://twitter.com/wetrackssl" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">@wetrackssl</a>
          </li>
          <li>
            Email: <a href="mailto:support@wetrackssl.com" className="text-blue-600 underline">support@wetrackssl.com</a>
          </li>
        </ul>
      </div>
      <div className="bg-white rounded-xl shadow p-6">
        <h2 className="text-xl font-semibold mb-4">Send us a message</h2>
        {submitted ? (
          <div className="text-green-600 font-medium">Thank you for reaching out! We'll get back to you soon.</div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-700 font-medium mb-1" htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-400"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-1" htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-400"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-1" htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                rows={5}
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-400"
                value={form.message}
                onChange={handleChange}
                required
              />
            </div>
            {error && <div className="text-red-600 font-medium">{error}</div>}
            <button
              type="submit"
              className="bg-primary-600 hover:bg-primary-700 text-white font-semibold px-6 py-2 rounded shadow"
            >
              Send Message
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Contact;
